import {routes} from "./routes";
import React from "react";
import {RequireAuth} from "../authentication/routing/RequireAuth";
import {sitRouteSpecifications} from "../sit/routing/sitRoutes";
import {routing} from "./routing";
import type {RouteSpecification} from "./routeClasses";
import {Route, Routes} from "react-router";
import type {MainComponentProps} from "../components/main/RootTypes";
import {MainComponent} from "../components/main/MainComponent";
import {LoginPage} from "../authentication/components/login/LoginPage";
import {NotFound} from "./pages/NotFound";
import {CALLBACK_ROUTE} from "../authentication/frontegg/FrontEggCallbackRoute";

const loginRoute: RouteSpecification = [
    {wrapper: null},
    routes.login,
    LoginPage,
    {notAuthenticated: true},
];
const notFoundRoute: RouteSpecification<MainComponentProps> = [
    {wrapper: MainComponent, wProps: {topHeader: null}},
    '*',
    NotFound,
    {notAuthenticated: true},
]

const rootRouteSpecifications = ([] as RouteSpecification[])
    .concat(routing as RouteSpecification[])
    .concat(sitRouteSpecifications as RouteSpecification[])
    .concat([loginRoute, CALLBACK_ROUTE, notFoundRoute] as RouteSpecification[])
    .filter(r => r);

export const RootRoutes: React.FC = () => {
    const children = rootRouteSpecifications.map(([baseOptions, path, component, overrideOptions], index) => {
        const options = overrideOptions ? {...baseOptions, ...overrideOptions} : baseOptions;

        const Wrapper: React.FC<{children?: React.ReactNode}> | null = options.wrapper;
        const wrapperProps = options.wrapper ? options.wProps as object : {};
        const Component: React.FC = component;
        const componentProps = options.componentProps as object;

        let result = <Component {...componentProps}/>;
        result = Wrapper ? <Wrapper {...wrapperProps}>{result}</Wrapper> : result;
        result = !options.notAuthenticated ? <RequireAuth>{result}</RequireAuth> : result;
        result = <React.Fragment>
            {/*<div>Route match: "{'' + path}" {JSON.stringify(options)}</div>*/}
            {result}
        </React.Fragment>;

        // react-router-v6 can only have Route elements in a Switch
        return <Route key={index} path={path} element={result}/>
    });
    return <Routes children={children}/>;
}
